import { useOrg } from '@/contexts/OrgContext';
import {
  defaultMemberAccessForRole,
  type MemberAccess,
  type ModuleId,
  MODULE_IDS,
  type SettingsSectionId,
  SETTINGS_SECTION_IDS
} from '@finvox/shared/member-access';

export function useMemberAccess(): MemberAccess | null {
  const { memberAccess, org } = useOrg();
  if (memberAccess) return memberAccess;
  if (!org?.role) return null;
  return defaultMemberAccessForRole(org.role);
}

export function useCanAccessModule(moduleId: ModuleId): boolean {
  const access = useMemberAccess();
  return access?.modules[moduleId] ?? false;
}

export function useCanAccessSettingsSection(sectionId: SettingsSectionId): boolean {
  const access = useMemberAccess();
  return access?.settings[sectionId] ?? false;
}

export { MODULE_IDS, SETTINGS_SECTION_IDS };
